import { Button } from '@/components/ui/button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <div className="flex h-screen flex-col items-center justify-center gap-20">
      <div className="text-[300px] font-semibold text-muted-foreground/60">
        404
      </div>
      <div className="flex flex-col items-center gap-4">
        <div className="text-2xl font-semibold">{t('page_not_found')}</div>
        <Button variant="success" onClick={() => navigate('/')}>
          {t('go_to_home')}
        </Button>
      </div>
    </div>
  );
};
